// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1dqGa","colMin":"styles_colMin__2cJEx","colCheckbox":"styles_colCheckbox__7JvHz"};